"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetsInternalApi = exports.DatasetsInternalApiFactory = exports.DatasetsInternalApiFp = exports.DatasetsInternalApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * DatasetsInternalApi - axios parameter creator
 * @export
 */
const DatasetsInternalApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Delete single dataset link from EA-PSM scheme item
         * @param {number} linkId Dataset link object to delete
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceDeleteLink: (linkId_1, schemeId_1, schemeItemId_1, ...args_1) => __awaiter(this, [linkId_1, schemeId_1, schemeItemId_1, ...args_1], void 0, function* (linkId, schemeId, schemeItemId, options = {}) {
            // verify required parameter 'linkId' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceDeleteLink', 'linkId', linkId);
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceDeleteLink', 'schemeId', schemeId);
            // verify required parameter 'schemeItemId' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceDeleteLink', 'schemeItemId', schemeItemId);
            const localVarPath = `/datasets/links/delete/{linkId}`
                .replace(`{${"linkId"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (schemeId !== undefined) {
                localVarQueryParameter['schemeId'] = schemeId;
            }
            if (schemeItemId !== undefined) {
                localVarQueryParameter['schemeItemId'] = schemeItemId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset links that are assigned to given EA-PSM scheme items
         * @param {ActiveLinksQueryData} [activeLinksQueryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetActiveLinks: (activeLinksQueryData_1, ...args_2) => __awaiter(this, [activeLinksQueryData_1, ...args_2], void 0, function* (activeLinksQueryData, options = {}) {
            const localVarPath = `/datasets/activeLinks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(activeLinksQueryData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetLinkIdentifiers: (...args_3) => __awaiter(this, [...args_3], void 0, function* (options = {}) {
            const localVarPath = `/datasets/linkIdentifiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get dataset links that are assigned to given EA-PSM scheme item
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetLinks: (schemeId_2, schemeItemId_2, ...args_4) => __awaiter(this, [schemeId_2, schemeItemId_2, ...args_4], void 0, function* (schemeId, schemeItemId, options = {}) {
            // verify required parameter 'schemeId' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetLinks', 'schemeId', schemeId);
            // verify required parameter 'schemeItemId' is not null or undefined
            (0, common_1.assertParamExists)('datasetResourceGetLinks', 'schemeItemId', schemeItemId);
            const localVarPath = `/datasets/links`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (schemeId !== undefined) {
                localVarQueryParameter['schemeId'] = schemeId;
            }
            if (schemeItemId !== undefined) {
                localVarQueryParameter['schemeItemId'] = schemeItemId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Save EA-PSM scheme item dataset link holder to the database
         * @param {SchemeItemDatasetLinkHolder} [schemeItemDatasetLinkHolder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceSaveSchemeItem: (schemeItemDatasetLinkHolder_1, ...args_5) => __awaiter(this, [schemeItemDatasetLinkHolder_1, ...args_5], void 0, function* (schemeItemDatasetLinkHolder, options = {}) {
            const localVarPath = `/datasets/save`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(schemeItemDatasetLinkHolder, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Save EA-PSM scheme item single dataset link to the database
         * @param {DatasetLink} [datasetLink]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceUpdateSingleLink: (datasetLink_1, ...args_6) => __awaiter(this, [datasetLink_1, ...args_6], void 0, function* (datasetLink, options = {}) {
            const localVarPath = `/datasets/updateLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(datasetLink, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DatasetsInternalApiAxiosParamCreator = DatasetsInternalApiAxiosParamCreator;
/**
 * DatasetsInternalApi - functional programming interface
 * @export
 */
const DatasetsInternalApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DatasetsInternalApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete single dataset link from EA-PSM scheme item
         * @param {number} linkId Dataset link object to delete
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceDeleteLink(linkId, schemeId, schemeItemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceDeleteLink(linkId, schemeId, schemeItemId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsInternalApi.datasetResourceDeleteLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme items
         * @param {ActiveLinksQueryData} [activeLinksQueryData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetActiveLinks(activeLinksQueryData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetActiveLinks(activeLinksQueryData, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsInternalApi.datasetResourceGetActiveLinks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetLinkIdentifiers(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetLinkIdentifiers(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsInternalApi.datasetResourceGetLinkIdentifiers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme item
         * @param {string} schemeId EA-PSM scheme UUID
         * @param {string} schemeItemId EA-PSM scheme item UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetLinks(schemeId, schemeItemId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceGetLinks(schemeId, schemeItemId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsInternalApi.datasetResourceGetLinks']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Save EA-PSM scheme item dataset link holder to the database
         * @param {SchemeItemDatasetLinkHolder} [schemeItemDatasetLinkHolder]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceSaveSchemeItem(schemeItemDatasetLinkHolder, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceSaveSchemeItem(schemeItemDatasetLinkHolder, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsInternalApi.datasetResourceSaveSchemeItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Save EA-PSM scheme item single dataset link to the database
         * @param {DatasetLink} [datasetLink]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceUpdateSingleLink(datasetLink, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.datasetResourceUpdateSingleLink(datasetLink, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DatasetsInternalApi.datasetResourceUpdateSingleLink']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.DatasetsInternalApiFp = DatasetsInternalApiFp;
/**
 * DatasetsInternalApi - factory interface
 * @export
 */
const DatasetsInternalApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DatasetsInternalApiFp)(configuration);
    return {
        /**
         * Delete single dataset link from EA-PSM scheme item
         * @param {DatasetsInternalApiDatasetResourceDeleteLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceDeleteLink(requestParameters, options) {
            return localVarFp.datasetResourceDeleteLink(requestParameters.linkId, requestParameters.schemeId, requestParameters.schemeItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme items
         * @param {DatasetsInternalApiDatasetResourceGetActiveLinksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetActiveLinks(requestParameters = {}, options) {
            return localVarFp.datasetResourceGetActiveLinks(requestParameters.activeLinksQueryData, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetLinkIdentifiers(options) {
            return localVarFp.datasetResourceGetLinkIdentifiers(options).then((request) => request(axios, basePath));
        },
        /**
         * Get dataset links that are assigned to given EA-PSM scheme item
         * @param {DatasetsInternalApiDatasetResourceGetLinksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceGetLinks(requestParameters, options) {
            return localVarFp.datasetResourceGetLinks(requestParameters.schemeId, requestParameters.schemeItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Save EA-PSM scheme item dataset link holder to the database
         * @param {DatasetsInternalApiDatasetResourceSaveSchemeItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceSaveSchemeItem(requestParameters = {}, options) {
            return localVarFp.datasetResourceSaveSchemeItem(requestParameters.schemeItemDatasetLinkHolder, options).then((request) => request(axios, basePath));
        },
        /**
         * Save EA-PSM scheme item single dataset link to the database
         * @param {DatasetsInternalApiDatasetResourceUpdateSingleLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetResourceUpdateSingleLink(requestParameters = {}, options) {
            return localVarFp.datasetResourceUpdateSingleLink(requestParameters.datasetLink, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DatasetsInternalApiFactory = DatasetsInternalApiFactory;
/**
 * DatasetsInternalApi - object-oriented interface
 * @export
 * @class DatasetsInternalApi
 * @extends {BaseAPI}
 */
class DatasetsInternalApi extends base_1.BaseAPI {
    /**
     * Delete single dataset link from EA-PSM scheme item
     * @param {DatasetsInternalApiDatasetResourceDeleteLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetResourceDeleteLink(requestParameters, options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetResourceDeleteLink(requestParameters.linkId, requestParameters.schemeId, requestParameters.schemeItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset links that are assigned to given EA-PSM scheme items
     * @param {DatasetsInternalApiDatasetResourceGetActiveLinksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetResourceGetActiveLinks(requestParameters = {}, options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetResourceGetActiveLinks(requestParameters.activeLinksQueryData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get all currently supported dataset link identifier options. These options are used identifying dataset purpose in EA-PSM software
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetResourceGetLinkIdentifiers(options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetResourceGetLinkIdentifiers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get dataset links that are assigned to given EA-PSM scheme item
     * @param {DatasetsInternalApiDatasetResourceGetLinksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetResourceGetLinks(requestParameters, options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetResourceGetLinks(requestParameters.schemeId, requestParameters.schemeItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Save EA-PSM scheme item dataset link holder to the database
     * @param {DatasetsInternalApiDatasetResourceSaveSchemeItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetResourceSaveSchemeItem(requestParameters = {}, options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetResourceSaveSchemeItem(requestParameters.schemeItemDatasetLinkHolder, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Save EA-PSM scheme item single dataset link to the database
     * @param {DatasetsInternalApiDatasetResourceUpdateSingleLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatasetsInternalApi
     */
    datasetResourceUpdateSingleLink(requestParameters = {}, options) {
        return (0, exports.DatasetsInternalApiFp)(this.configuration).datasetResourceUpdateSingleLink(requestParameters.datasetLink, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DatasetsInternalApi = DatasetsInternalApi;
//# sourceMappingURL=datasets-internal-api.js.map